/**
 * KPI Configuration
 * Defines all KPIs shown in the Overview dashboard
 */

export const KPI_CONFIGS = [
  {
    id: 'dau',
    label: 'Daily Active Users',
    description: 'Unique users in userActivity over the last 24 hours.',
    drilldownPath: '/PlatformEngineer/overview/dau',
  },
  {
    id: 'wau',
    label: 'Weekly Active Users',
    description: 'Unique users in userActivity over the last 7 days.',
    drilldownPath: '/PlatformEngineer/overview/wau',
  },
  {
    id: 'activeSessions',
    label: 'Active Sessions',
    description: 'Currently active entries in sessions.',
    drilldownPath: '/PlatformEngineer/identity/sessions',
  },
  {
    id: 'otpRate',
    label: 'OTP Request Rate',
    description: 'OTP, clientLoginOtps, and passwordResetOtps in the last 24 hours.',
    drilldownPath: '/PlatformEngineer/security/otp',
  },
  {
    id: 'docViews',
    label: 'Document Views',
    description: 'Views from documentBankViews over selected period.',
    drilldownPath: '/PlatformEngineer/documents/views',
  },
  {
    id: 'kbUsage',
    label: 'Knowledge Base Usage',
    description: 'KnowledgeBaseAnalytics events.',
    drilldownPath: '/PlatformEngineer/knowledge/analytics',
  },
  {
    id: 'templateUsage',
    label: 'Template Usage',
    description: 'TemplatesAnalytics counts.',
    drilldownPath: '/PlatformEngineer/templates/analytics',
  },
  {
    id: 'securityIncidents',
    label: 'Security Incidents',
    description: 'High/critical events in security_logs.',
    drilldownPath: '/PlatformEngineer/security/incidents',
  },
  {
    id: 'programRatings',
    label: 'Program Ratings',
    description: 'Average rating from programRatings.',
    drilldownPath: '/PlatformEngineer/programs/ratings',
    suffix: '/5',
  },
  {
    id: 'coachingEngagement',
    label: 'Coaching Engagement',
    description: 'Sessions vs coachingLog entries.',
    drilldownPath: '/PlatformEngineer/programs/coaching',
  },
  {
    id: 'productThroughput',
    label: 'Product Dev Throughput',
    description: 'Submissions per period from productDevelopmentSubmissions.',
    drilldownPath: '/PlatformEngineer/product-dev/submissions',
  },
  {
    id: 'auditPassRate',
    label: 'Audit Pass Rate',
    description: 'Pass vs fail in productAudits.',
    drilldownPath: '/PlatformEngineer/product-dev/audits',
    suffix: '%',
  },
  {
    id: 'orgClientGrowth',
    label: 'Org & Client Growth',
    description: 'New organizations and clients over time.',
    drilldownPath: '/PlatformEngineer/clients/growth',
  },
];

export const getKpiById = id => KPI_CONFIGS.find(kpi => kpi.id === id);
